module.exports = __webpack_public_path__ + "img/caiwuzhuangkuang.197779af.png";